/* eslint-disable no-shadow */
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Link, Redirect } from 'react-router-dom';
import ResultsTable from './Table/ResultsTable';
import ScreeningFrequency from '../Modals/ScreeningFrequency';
import ApprovalStatus from '../Modals/ApprovalStatus';
import ViewHistoryModal from '../Modals/ViewHistoryModal';
import RequestModal from '../Modals/RequestModal';
import { Modal } from '@mui/material';
import CasesAPI from 'api/CasesAPI';
import { isReScreenableDocType } from 'utils/reScreening';
import TariffChangeBanner from './TariffChangeBanner';
import { useHistory } from 'react-router-dom';
import pako from 'pako';
import { Buffer } from 'buffer';
import { useSnackbar } from 'notistack';
import EmailAPI from 'api/EmailAPI';
import {
  handleScreenNotification,
  handleUpdateTicketNotification,
} from 'utils/NotificationsFuncs';
import TariffPage from 'pages/tariffs/TariffPage';
import AIEvalProduct from 'components/Screening/searchComponents/AIEvalProduct';
import ModalLayout from 'components/DataFiltering/ModalLayout';
import DateSelector from 'components/Screening/filters/DateSelector';
import { format } from 'date-fns';
import AutomationAPI from 'api/AutomationAPI';
import { getNewDocs } from 'utils/resultsComparison';
import AIEvalEntity from 'components/Screening/searchComponents/AIEvalEntity';
import EntityTicketResults from './EntityTicketResults';
import BeneficialOwnershipTicketResults from './BeneficialOwnershipTicketResults';
import { didSecondLayerRun } from 'utils/beneficialOwnershipLayers';
import { buildOwnershipGraph } from 'utils/beneficialOwnershipGraph';
import EntityScreeningResultsTable from 'components/Screening/tables/entityTable/EntityScreeningResultsTable';
import {
  screeningTicketBeneficialOwnershipPDF,
  screeningTicketEntityPDF,
  screeningTicketProductPDF,
  screeningTicketTariffPDF,
} from 'components/Common/EntityTicketPdf';
import { formatDate } from 'utils/dateFormater';
import {
  cbp7501EntrySummaryPDF,
  screeningTicketPDF,
} from 'components/Common/PDFKitManage';
interface IResultsProps {
  cur_user: any;
  cur_case: any;
  trigger: boolean;
  setTrigger: any;
  setDownloadModal: any;
  setShareModal: any;
  setIsCommentsModalOpen: any;
  triggerCSV: boolean;
  triggerSendPdf?: boolean;
  whitelistEntity: (content: any) => void;
  isBulkTicket: boolean;
  setTriggerCSV: any;
  setTriggerSendPdf?: any;
  triggerRescreen?: boolean;
  setTriggerRescreen?: any;
  selectedVersionIndex?: number;
  downloadOpts?: string;
  fileName?: string;
  sendPdfFileName?: string;
  sendPdfEmailRecipients?: string[];
  onTariffPdfSendComplete?: (success: boolean) => void;
  /** Beneficial Ownership only: switch the ticket to the Ownership Tree tab. */
  onViewOwnershipTree?: () => void;
}

interface value {
  searchVal: string;
  type: string;
}
export interface automationParams {
  values?: value[];
  entState?: IEntityState;
  comState?: ICommodityState;
  row?: string;
}

interface IEntityState {
  fuzzy: boolean;
  dateRange: string[];
  lenses: string[];
  countries: string[];
  agencies: string[];
  lists: string[];
}

interface ICommodityState {
  fuzzy: boolean;
  dateRange: string[];
  comLenses: string[];
  countries: string[];
  agencies: string[];
  lists: string[];
}

const ResultsComponent: React.FC<IResultsProps> = ({
  cur_user,
  cur_case,
  isBulkTicket,
  trigger,
  setTrigger,
  setShareModal,
  setIsCommentsModalOpen,
  triggerCSV,
  triggerSendPdf = false,
  setTriggerCSV,
  setTriggerSendPdf,
  triggerRescreen = false,
  setTriggerRescreen,
  setDownloadModal,
  whitelistEntity,
  selectedVersionIndex = 0,
  downloadOpts,
  fileName,
  sendPdfFileName,
  sendPdfEmailRecipients = [],
  onTariffPdfSendComplete,
  onViewOwnershipTree,
}) => {
  const history = useHistory();
  if (!cur_case) {
    history.push('/bite-monitor');
    return <></>;
  }

  const componentRef = useRef<HTMLDivElement>(null);
  const tariffComponentRef = useRef<HTMLDivElement>(null);
  const docType = cur_case.data.docType || '';
  const savedResults = Array.isArray(cur_case.data.results)
    ? cur_case.data.results
    : [];
  const savedEntityFilter = cur_case.data.entityFilter || {};
  const savedCommodityFilter = cur_case.data.commodityFilter || {};

  const [isFrequencyModalOpen, setIsFrequencyModalOpen] = useState(false);
  const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [isRequestModalOpen, setIsRequestModalOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState(
    cur_case.data.activeFilter ? cur_case.data.activeFilter : 'BITE Lens',
  );
  const [selectedOpts, setSelectedOpts] = useState([]);
  const [curLevel, setCurLevel] = useState(2);
  const [filterOpts, setFilterOpts] = useState<any>({});
  const [screenParmsModal, setScreenParamsModal] = useState(false);
  const [newTab, setNewTab] = useState(false);
  const [curVersion, setCurVersion] = useState<any>(
    savedResults.length > 0
      ? savedResults[selectedVersionIndex] ?? savedResults[0]
      : undefined,
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [productTablePage, setProductTablePage] = useState(0);
  const [currentItems, setCurrentItems] = useState<any[]>([]);
  const [removeTrigger, setRemoveTrigger] = useState(false);
  const [aiSums, setAISums] = useState<any>([]);
  const [submit, setSubmit] = useState<any>({
    trigger: false,
    reason: '',
    location: '',
  });

  useEffect(() => {
    if (isBulkTicket) {
      setCurLevel(1);
    }
  }, [isBulkTicket]);

  const [entityState, setEntityState] = useState({
    lenses: savedEntityFilter.lenses || [],
    countries: savedEntityFilter.countries || [],
    agencies: savedEntityFilter.agencies || [],
    lists: savedEntityFilter.lists || [],
    fuzzy: savedEntityFilter.entRes || false,
    dateRange: savedEntityFilter.filterDate || [],
  });

  const [commodityState, setCommodityState] = useState({
    comLenses: savedCommodityFilter.lenses || [],
    countries: savedCommodityFilter.countries || [],
    agencies: savedCommodityFilter.agencies || [],
    lists: savedCommodityFilter.lists || [],
    fuzzy: savedCommodityFilter.entRes || false,
    dateRange: savedCommodityFilter.filterDate || [],
  });

  const [appliedFilter] = useState<any>({});
  const [openDate, setOpenDate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPdfExporting, setIsPdfExporting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const blobToBase64 = async (blob: Blob): Promise<string> => {
    const buffer = await blob.arrayBuffer();
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const chunkSize = 0x8000;

    for (let i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
    }

    return btoa(binary);
  };

  const decompressData = (compressedData: any) => {
    if (!compressedData || compressedData.length === 0) {
      return {};
    }

    const base64Data = Array.isArray(compressedData)
      ? compressedData[0]
      : compressedData;

    if (!base64Data) {
      return {};
    }

    try {
      const compressedBuffer = Buffer.from(base64Data, 'base64');
      const decompressed = pako.ungzip(compressedBuffer, { to: 'string' });
      if (decompressed === undefined) {
        return {};
      }
      return JSON.parse(decompressed);
    } catch (error) {
      console.error('Failed to decompress data:', error);
      return {};
    }
  };
  const reloadPage = () => {
    document.body.style.opacity = '0.5'; // Fade effect
    setTimeout(() => window.location.reload(), 3000);
  };

  const decompData =
    savedResults.length > 0
      ? decompressData(
          savedResults[savedResults.length - 1].allResults,
        )
      : [];

  let parsedResults = decompData;
  const [passedDownResults, setPassedDownResults] = useState(decompData);
  const dt = new Date();
  const dtWithoutTz = new Date(
    dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000,
  );
  const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');

  // Single-entity Saved Work tickets ('Person / Company', non-bulk) render the
  // redesigned Entity Screening display (toggleable full-width AI panels + the
  // new styled results table) and download as the clean pdfkit report.
  // Reconstruct the table props from the saved (compressed) ticket data into
  // the shape EntityScreeningResultsTable expects.
  const isEntityTicket =
    docType === 'Person / Company' && !isBulkTicket;
  const isProductScreenTicket = docType.includes('Product Screen');
  const isBeneficialOwnershipTicket = docType === 'Beneficial Ownership';
  const beneficialOwnershipWorkflowData = Array.isArray(
    cur_case.data.workflowData,
  )
    ? cur_case.data.workflowData[0] || {}
    : cur_case.data.workflowData || {};
  const beneficialOwnershipEntity =
    beneficialOwnershipWorkflowData.entity_name ||
    cur_case.data.classificationValue ||
    cur_case.data.commodity?.commodityName ||
    cur_case.data.ticketName;
  const beneficialOwnershipCountry =
    beneficialOwnershipWorkflowData.country ||
    cur_case.data.commodity?.destinationCountry ||
    'Not provided';

  const entityTicketData = useMemo(() => {
    if (!isEntityTicket) {
      return null;
    }
    const buildResultBundle = (hits: any[], total: number) => ({
      isLoading: false,
      data: [
        {
          result: {
            body: {
              hits: {
                hits: hits.map((source: any) => ({ _source: source })),
                total: { value: total },
              },
            },
          },
        },
      ],
    });

    const versionData = curVersion ? decompressData(curVersion.allResults) : [];
    const entityDocs = Array.isArray(versionData)
      ? versionData.flatMap((entry: any) => entry?.docs || [])
      : [];
    const entityTotal = curVersion?.allTotal ?? entityDocs.length;

    const ownershipDecomp: any = cur_case.data.ownershipResults
      ? decompressData(cur_case.data.ownershipResults)
      : {};
    const ownershipDocs = Array.isArray(ownershipDecomp?.docs)
      ? ownershipDecomp.docs
      : [];
    const ownershipTotal = ownershipDecomp?.total ?? ownershipDocs.length;

    return {
      results: buildResultBundle(entityDocs, entityTotal),
      ownershipResults: buildResultBundle(ownershipDocs, ownershipTotal),
      entityDocs: entityDocs,
      ownershipDocs: ownershipDocs,
      entityTotal: entityTotal,
      ownershipTotal: ownershipTotal,
    };
  }, [isEntityTicket, curVersion, cur_case.data.ownershipResults]);

  // Assemble the data the pdfkit report builder needs from the saved ticket.
  const preparedBy =
    [cur_user?.basics?.firstName, cur_user?.basics?.lastName]
      .filter(Boolean)
      .join(' ')
      .trim() ||
    cur_user?.basics?.email ||
    'BITE Entity Screening';

  const buildEntityReportData = () => ({
    ticketName: cur_case.data.ticketName,
    entity: cur_case.data.entity,
    aiSums: cur_case.data.aiSums || [],
    beneficialOwnership: cur_case.data.beneficialOwnership || null,
    adverseMedia: cur_case.data.adverseMedia || null,
    entityDocs: entityTicketData?.entityDocs || [],
    ownershipDocs: entityTicketData?.ownershipDocs || [],
    entityTotal: entityTicketData?.entityTotal,
    ownershipTotal: entityTicketData?.ownershipTotal,
    preparedBy: preparedBy,
  });

  const flattenSavedDocs = (items: any[]) =>
    Array.isArray(items)
      ? items.flatMap((item: any) =>
          Array.isArray(item?.docs) ? item.docs : item ? [item] : [],
        )
      : [];

  const productScreeningResults = useMemo(() => {
    const docs = flattenSavedDocs(passedDownResults);
    const hits = docs.map((doc: any) =>
      doc?._source ? doc : { _source: doc },
    );

    return {
      isLoading: false,
      data: [
        {
          result: {
            body: {
              hits: {
                hits: hits,
                total: { value: hits.length },
              },
            },
          },
        },
      ],
    };
  }, [passedDownResults]);

  useEffect(() => {
    setProductTablePage(0);
  }, [passedDownResults]);

  const formatReportMoney = (value: any) => {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return undefined;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
    }).format(numeric);
  };

  const buildProductReportData = () => {
    const docs = flattenSavedDocs(passedDownResults);
    const tariffSnapshot = cur_case.data.tariffResults || {};
    const commodity = cur_case.data.commodity || {};
    const aiSummary = cur_case.data.aiSums?.[0] || {};
    const inputs = tariffSnapshot.inputs || {};
    const base = tariffSnapshot.base || {};
    const math = tariffSnapshot.math || {};

    return {
      ticketName: cur_case.data.ticketName,
      docType: docType,
      product: {
        name:
          commodity.productName ||
          commodity.name ||
          aiSummary.product_name ||
          inputs.productName ||
          inputs.productDescription ||
          cur_case.data.ticketName,
        htsCode:
          commodity.harmonizedScheduleCode ||
          inputs.htsCode ||
          inputs.productCode ||
          aiSummary.hts_code ||
          '',
        country:
          commodity.countryOfOrigin ||
          inputs.originCountry ||
          inputs.loadingCountry ||
          '',
        description: commodity.commodityName || '',
        // Import jurisdiction the screen was run for (e.g. 'European Union').
        // Only present on region-based import tickets.
        region: commodity.tradeRegion || commodity.tradeType || '',
      },
      aiSums: cur_case.data.aiSums || [],
      productDocs: docs,
      productTotal: docs.length,
      tariffSummary: {
        baseDutyRate: base.baseDutyRate || '',
        additionalDutyRate: math.additionalDutyRateDisplay || '',
        dutyCost: formatReportMoney(math.dutyCost),
        totalCost: formatReportMoney(math.totalCost),
      },
      preparedBy: preparedBy,
    };
  };

  const buildTariffReportData = () => ({
    ticketName: cur_case.data.ticketName,
    docType: docType,
    tariffResults: cur_case.data.tariffResults || {},
    preparedBy: preparedBy,
  });

  const buildBeneficialOwnershipReportData = () => {
    const result =
      cur_case.data.beneficialOwnership ||
      beneficialOwnershipWorkflowData.result ||
      {};

    return {
      ticketName: cur_case.data.ticketName,
      entityName: beneficialOwnershipEntity,
      country: beneficialOwnershipCountry,
      // Derived from the saved workflow state rather than the stored
      // boolean, so tickets saved with the wrong flag still export
      // correctly. See utils/beneficialOwnershipLayers.
      secondLayer: didSecondLayerRun(cur_case.data),
      sanctionsFlag: result.sanctions_flag || '',
      sanctionsSummary: result.sanctions_summary || '',
      executiveSummary: result.executive_summary || '',
      summary:
        result.general_description ||
        result.summary ||
        result.beneficial_ownership_summary ||
        '',
      owners: Array.isArray(result.owners) ? result.owners : [],
      keyFindings: Array.isArray(result.key_findings)
        ? result.key_findings
        : [],
      associatedEntities: Array.isArray(result.associated_entities)
        ? result.associated_entities
        : [],
      supportingLinks: Array.isArray(result.supporting_links)
        ? result.supporting_links
        : [],
      ownershipGraph: buildOwnershipGraph(cur_case.data),
      preparedBy: preparedBy,
    };
  };

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  const handleFrequencyCloseModal = () => {
    setIsFrequencyModalOpen(false);
  };
  const handleApprovalCloseModal = () => {
    setIsApprovalModalOpen(false);
  };
  const handleHistoryCloseModal = () => {
    setIsHistoryModalOpen(false);
  };

  const handleClear = () => {
    setEntityState({
      lenses: savedEntityFilter.lenses || [],
      countries: savedEntityFilter.countries || [],
      agencies: savedEntityFilter.agencies || [],
      lists: savedEntityFilter.lists || [],
      fuzzy: savedEntityFilter.entRes || false,
      dateRange: savedEntityFilter.filterDate || [],
    });
    setCommodityState({
      comLenses: savedCommodityFilter.lenses || [],
      countries: savedCommodityFilter.countries || [],
      agencies: savedCommodityFilter.agencies || [],
      lists: savedCommodityFilter.lists || [],
      fuzzy: savedCommodityFilter.entRes || false,
      dateRange: savedCommodityFilter.filterDate || [],
    });
    setSubmit({
      reason: 'apply',
      trigger: !submit.trigger,
      location: 'Entity',
    });
  };

  const handleDateChange = (newValue: any) => {
    const arr: any = [...newValue];
    if (newValue !== null) {
      arr.forEach((date_item: any, index: number) => {
        if (date_item !== null) {
          arr[index] = formatted_dt;
        }
      });
    }
    setEntityState({ ...entityState, dateRange: arr });
    setCommodityState({ ...commodityState, dateRange: arr });
  };

  const handleRequestCloseModal = () => {
    setIsRequestModalOpen(false);
  };

  const resetTable = () => {
    setPassedDownResults(parsedResults);
    setCurLevel(isBulkTicket ? 1 : 2);
    setActiveFilter('BITE Lens');
    setSelectedOpts(filterOpts['BITE Lens']);
  };

  const removeHit = async (id: string, name: string) => {
    const user = cur_user.basics || {};
    const existingHits = cur_case.data.removedHits || [];

    const idExists = existingHits.includes(id);

    const updatedHits = idExists
      ? existingHits.filter((hitId: string) => hitId !== id)
      : [...existingHits, id];

    const actObj: any = {
      user: {
        kc_id: user.id,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
      },
      action: idExists
        ? `restored the result: ${name}`
        : `removed the result: ${name}`,
    };

    const update: any = {
      _id: cur_case.data._id,
      removedHits: updatedHits,
      activity: [...cur_case.data.activity, actObj],
    };

    await CasesAPI.updateCase(update);
    setTrigger(!trigger);
    setRemoveTrigger(!removeTrigger);
  };

  const changeFreq = async (newFreq: string) => {
    const actObj: any = {
      user: {
        kc_id: cur_user.basics?.id,
        email: cur_user.basics?.email,
        firstName: cur_user.basics?.firstName,
        lastName: cur_user.basics?.lastName,
      },
      action: `changed the screening frequency from ${cur_case.data.frequency} to ${newFreq}`,
    };
    const update: any = {
      _id: cur_case.data._id,
      frequency: newFreq,
      activity: [...cur_case.data.activity, actObj],
    };
    await CasesAPI.updateCase(update);
    setTrigger(!trigger);
  };

  const changeStatus = async (newStatus: string) => {
    const actObj: any = {
      user: {
        kc_id: cur_user.basics?.id,
        email: cur_user.basics?.email,
        firstName: cur_user.basics?.firstName,
        lastName: cur_user.basics?.lastName,
      },
      action: `changed the status from ${cur_case.data.status} to ${newStatus}`,
      timeStamp: Date.now(),
    };
    const update: any = {
      _id: cur_case.data._id,
      status: newStatus,
      activity: [...cur_case.data.activity, actObj],
    };
    const res = await CasesAPI.updateCase(update);
    if (res?.success) {
      if (
        cur_case.data.sharedWith.length > 0 &&
        cur_user.basics.Id === cur_case.data.createdBy
      ) {
        cur_case.data.sharedWith.forEach(async (user: string) => {
          handleUpdateTicketNotification(
            cur_case.data.ticketName,
            cur_user,
            user,
            cur_case.data._id,
          );
        });
      } else if (
        cur_case.data.sharedWith.length > 0 &&
        cur_user.basics.Id !== cur_case.data.createdBy
      ) {
        const shareArr = cur_case.data.sharedWith.filter((user: string) => {
          return user !== cur_user.basics.id && user !== cur_user.basics.email;
        });
        shareArr.push(cur_case.data.createdBy);
        shareArr.forEach(async (user: string) => {
          handleUpdateTicketNotification(
            cur_case.data.ticketName,
            cur_user,
            user,
            cur_case.data._id,
          );
        });
      }
    } else {
      enqueueSnackbar('There was an error updating the status', {
        variant: 'error',
      });
    }
    setTrigger(!trigger);
  };

  const handleFilterClick = () => {
    const res = filterDataByKey(parsedResults, activeFilter, selectedOpts);
    setPassedDownResults(res);
  };

  const handleVisClick = (index: number) => {
    if (currentPage > 1) {
      const updatedResults = passedDownResults.filter(
        (res: any, i: number) => i !== index,
      );
      setPassedDownResults(updatedResults);
      if (currentItems.length <= 1) {
        setCurrentPage(currentPage - 1);
      }
    } else {
      const updatedResults = passedDownResults.filter(
        (res: any, i: number) => i !== index,
      );
      setPassedDownResults(updatedResults);
    }
  };

  const extractValuesByKeys = (data: any[], keys: string[]) => {
    // Initialize an object to store the unique values for each key
    const result = keys.reduce((acc: any, key: string) => {
      acc[key] = [];
      return acc;
    }, {});
    // Iterate over the array of objects
    data.forEach((item) => {
      if (Array.isArray(item.docs)) {
        item.docs.forEach((doc: any) => {
          keys.forEach((key) => {
            if (doc[key] && !result[key].includes(doc[key])) {
              result[key].push(doc[key]);
            }
          });
        });
      }
    });

    return result;
  };

  const filterDataByKey = (data: any, key: string, allowedValues: string[]) => {
    return data
      ?.map((item: any) => {
        if (Array.isArray(item?.docs)) {
          return {
            ...item,
            docs: item?.docs?.filter((doc: any) =>
              allowedValues?.includes(doc[key]),
            ),
          };
        }
        return item;
      })
      .filter((item: any) => item?.docs && item?.docs?.length > 0);
  };

  const getOpts = () => {
    const keysToExtract = [
      'BITE Lens',
      'Source Country',
      'Agency',
      'List Name',
    ];
    const result = extractValuesByKeys(parsedResults, keysToExtract);

    setFilterOpts(result);
    setSelectedOpts(
      cur_case.data.selectedOpts.length > 0
        ? cur_case.data.selectedOpts
        : result['BITE Lens'],
    );
  };

  // const headers = ['Field Input', 'Row #', 'Dataset', 'Total Hits'];

  const handleCSV = async () => {
    if (docType === 'Tariff') {
      if (downloadOpts === 'CSV') {
        await handleExportTariffs();
        enqueueSnackbar('CSV file downloaded', {
          variant: 'success',
        });
        setTriggerCSV(false);
        setDownloadModal(false);
      } else if (downloadOpts === 'PDF') {
        try {
          const safeTicketName =
            (typeof cur_case?.data?.ticketName === 'string' &&
              cur_case.data.ticketName) ||
            'tariff_ticket';
          const resolvedFileName = `${
            fileName ? fileName : safeTicketName
          }.pdf`;
          await screeningTicketTariffPDF(
            buildTariffReportData(),
            resolvedFileName,
          );

          enqueueSnackbar('PDF file downloaded', {
            variant: 'success',
          });
        } catch (error: any) {
          console.error('[TariffPDF] trigger:error', error);
          enqueueSnackbar(
            `Failed to download tariff PDF: ${
              error?.message || 'Unknown error'
            }`,
            {
              variant: 'error',
            },
          );
        } finally {
          setTriggerCSV(false);
          setDownloadModal(false);
        }
      } else if (downloadOpts === 'CBP') {
        try {
          const safeTicketName =
            (typeof cur_case?.data?.ticketName === 'string' &&
              cur_case.data.ticketName) ||
            'tariff_ticket';
          const cbpFileName = `${
            fileName ? fileName : safeTicketName
          }_CBP_7501_${format(new Date(), 'yyyy-MM-dd')}.pdf`;

          await cbp7501EntrySummaryPDF(cur_case?.data, cbpFileName, {
            templateUrl: '/templates/CBP_Form_7501.pdf',
            flatten: false,
          });
          enqueueSnackbar('CBP Form 7501 PDF downloaded', {
            variant: 'success',
          });
        } catch (error: any) {
          console.error('[CBP7501] trigger:error', error);
          enqueueSnackbar(
            `Failed to generate CBP PDF: ${error?.message || 'Unknown error'}`,
            {
              variant: 'error',
            },
          );
        } finally {
          setTriggerCSV(false);
          setDownloadModal(false);
        }
      }
    } else if (isEntityTicket) {
      // Entity tickets export the clean pdfkit report (Risk Evaluation, AI
      // Results, Top 25 Matches, Top 25 Ownership Matches) built from saved data.
      try {
        await screeningTicketEntityPDF(
          buildEntityReportData(),
          `${cur_case.data.ticketName}.pdf`,
        );
      } catch (error: any) {
        enqueueSnackbar(
          `Failed to generate report PDF: ${error?.message || 'Unknown error'}`,
          { variant: 'error' },
        );
      } finally {
        setTriggerCSV(false);
      }
    } else if (docType.includes('Product Screen')) {
      try {
        await screeningTicketProductPDF(
          buildProductReportData(),
          `${cur_case.data.ticketName}.pdf`,
        );
      } catch (error: any) {
        enqueueSnackbar(
          `Failed to generate report PDF: ${error?.message || 'Unknown error'}`,
          { variant: 'error' },
        );
      } finally {
        setTriggerCSV(false);
      }
    } else if (isBeneficialOwnershipTicket) {
      try {
        await screeningTicketBeneficialOwnershipPDF(
          buildBeneficialOwnershipReportData(),
          `${cur_case.data.ticketName}.pdf`,
        );
      } catch (error: any) {
        enqueueSnackbar(
          `Failed to generate report PDF: ${error?.message || 'Unknown error'}`,
          { variant: 'error' },
        );
      } finally {
        setTriggerCSV(false);
      }
    } else if (passedDownResults.length >= 1) {
      // exportToCSV(`${cur_case.data.ticketName}.csv`, passedDownResults, headers, 'monitor');
      try {
        const shouldUsePdfLayout = docType === 'Person / Company';
        if (shouldUsePdfLayout) {
          setIsPdfExporting(true);
          await new Promise((resolve) => setTimeout(resolve, 150));
        }
        await screeningTicketPDF(
          componentRef,
          `${cur_case.data.ticketName}.pdf`,
        );
      } finally {
        setIsPdfExporting(false);
        setTriggerCSV(false);
      }
    } else {
      enqueueSnackbar('No Result Data to Export', { variant: 'error' });
      setTriggerCSV(false);
    }
  };

  const handleSendResultPdf = async () => {
    let sendSucceeded = false;

    try {
      const safeTicketName =
        (typeof cur_case?.data?.ticketName === 'string' &&
          cur_case.data.ticketName) ||
        'tariff_ticket';
      const resolvedFileName = `${
        sendPdfFileName ? sendPdfFileName : safeTicketName
      }.pdf`;
      const pdfBlob =
        docType === 'Tariff'
          ? await screeningTicketTariffPDF(
              buildTariffReportData(),
              resolvedFileName,
              { shouldDownload: false },
            )
          : isEntityTicket
          ? await screeningTicketEntityPDF(
              buildEntityReportData(),
              resolvedFileName,
              { shouldDownload: false },
            )
          : docType.includes('Product Screen')
          ? await screeningTicketProductPDF(
              buildProductReportData(),
              resolvedFileName,
              { shouldDownload: false },
            )
          : isBeneficialOwnershipTicket
          ? await screeningTicketBeneficialOwnershipPDF(
              buildBeneficialOwnershipReportData(),
              resolvedFileName,
              { shouldDownload: false },
            )
          : await screeningTicketPDF(componentRef, resolvedFileName, {
              shouldDownload: false,
            });

      if (!pdfBlob || sendPdfEmailRecipients.length === 0) {
        throw new Error('Please add at least one recipient email');
      }

      const pdfBase64 = await blobToBase64(pdfBlob);
      const senderName = `${cur_user?.basics?.firstName || ''} ${
        cur_user?.basics?.lastName || ''
      }`.trim();
      const emailRes = await EmailAPI.sendTariffResultPdf({
        recipients: sendPdfEmailRecipients,
        fileName: resolvedFileName,
        pdfBase64: pdfBase64,
        docType: cur_case?.data?.docType,
        ticketId: cur_case?.data?._id,
        ticketName: cur_case?.data?.ticketName,
        senderName: senderName,
        senderEmail: cur_user?.basics?.email,
      });

      if (emailRes?.success) {
        sendSucceeded = true;
        enqueueSnackbar('PDF emailed successfully', {
          variant: 'success',
        });
      } else {
        throw new Error(emailRes?.result || 'Failed to send PDF email');
      }
    } catch (error: any) {
      enqueueSnackbar(
        `Failed to send result PDF: ${error?.message || 'Unknown error'}`,
        {
          variant: 'error',
        },
      );
    } finally {
      setTriggerSendPdf?.(false);
      onTariffPdfSendComplete?.(sendSucceeded);
    }
  };

  // --- Configuration: Headers matching your CSV Template exactly ---
  const EXPORT_HEADERS = [
    // Row 1 (Codes)
    'CBP Form 7501 Field:',
    '3',
    '7',
    '9',
    '10',
    '15',
    '21',
    '22',
    '31',
    '33A',
    '',
    '36A',
    '37A',
    '38',
    '38',
    '39',
    '41',
    '43',
    '44',
    '',
    // Row 2 (Descriptions) - Used for reference/readability in the CSV
    'Transaction Number',
    'Summary Date',
    'Entry Date',
    'Mode of Transport',
    'Country of Origin',
    'Export Date',
    'Country of Melt and Pour',
    'Primary Country of Smelt',
    'Line Number',
    'HTSUS Number',
    'Material Percent',
    'Entered Value',
    'HTSUS Rate',
    'Duty Amount',
    'Other Fees',
    'Total Entered Value',
    'Total Duty',
    'Total Other Fees',
    'Total Amount Due',
    'Product Code',
  ];

  // Escape for CSV
  const escapeCsv = (val: any) => {
    const stringVal = String(val ?? '');
    if (
      stringVal.includes(',') ||
      stringVal.includes('"') ||
      stringVal.includes('\n')
    ) {
      return `"${stringVal.replace(/"/g, '""')}"`;
    }
    return stringVal;
  };

  const formatPercentage = (value: number | string): string => {
    // Ensure input is a number
    const num = typeof value === 'string' ? parseFloat(value) : value;
    // Handle invalid inputs gracefully
    if (isNaN(num)) {
      return '-';
    }
    return new Intl.NumberFormat('en-US', {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    }).format(num / 100);
  };

  const handleExportTariffs = async () => {
    try {
      // ---------------- Helpers ----------------
      const parseMaybeJson = (v: any) => {
        if (typeof v !== 'string') return v;
        try {
          return JSON.parse(v);
        } catch {
          return v;
        }
      };

      const mongoDateToYMD = (v: any) => {
        // Supports Mongo Extended JSON: { $date: "..." }, ISO string, Date, or yyyy-mm-dd
        const raw = v?.$date ?? v;
        if (!raw) return '';

        // Already yyyy-mm-dd
        if (typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(raw))
          return raw;

        const d = raw instanceof Date ? raw : new Date(raw);
        if (Number.isNaN(d.getTime())) return '';

        return format(d, 'yyyy-MM-dd');
      };

      // If you still want to leverage existing formatDate, only feed it yyyy-mm-dd
      const safeFormatDate = (v: any) => {
        const ymd = mongoDateToYMD(v);
        if (!ymd) return '';
        try {
          return formatDate(ymd);
        } catch {
          // If formatDate is strict and still throws, just return ymd (already correct)
          return ymd;
        }
      };

      // ---------------- 1) Fetch & Normalize ----------------
      const raw = parseMaybeJson(cur_case?.data);

      // DB can return a single ticket object or an array of tickets
      const tickets: any[] = Array.isArray(raw) ? raw : raw ? [raw] : [];

      if (tickets.length === 0) {
        enqueueSnackbar('No tariff data available to export', {
          variant: 'warning',
        });
        return;
      }

      // ---------------- 2) Build Rows ----------------
      const dataRows: string[][] = [];

      // Header rows
      dataRows.push(EXPORT_HEADERS.slice(0, 20));
      dataRows.push(EXPORT_HEADERS.slice(20));

      const summaryDate = format(new Date(), 'yyyy-MM-dd');

      tickets.forEach((ticket: any, transactionIndex: number) => {
        const tr = ticket?.tariffResults ?? {};
        const trInputs = tr?.inputs ?? {};
        const trResults = tr?.results ?? {};
        const trMath = tr?.math ?? {};

        const inputs = {
          entryDate: safeFormatDate(trInputs.effectDate), // ✅ fixed
          loadingDate: safeFormatDate(trInputs.loadDate), // ✅ fixed
          mode: ticket?.trans_method || '',
          origin:
            ticket?.commodity?.countryOfOrigin || trInputs.originCountry || '',
          smeltPour: ticket?.country_of_smelt_pour || '',
          totalValue: Number(trInputs.productValue ?? 0),
          productCode: ticket?.product_code || '',
          materialPct:
            trResults?.hasSplit === true
              ? Number(trInputs.materialPct ?? 0)
              : 1,
          hts:
            ticket?.commodity?.harmonizedScheduleCode || trInputs.htsCode || '',
        };

        // Totals
        const totalEnteredValue = inputs.totalValue;
        const totalDuty = Number(trMath.dutyCost ?? 0);
        const mpf = Number(trMath.mpf ?? 0);
        const hmf = Number(trMath.hmf ?? 0);
        const totalFees = mpf + hmf;
        const totalAmountDue = Number(trMath.totalCost ?? 0);

        // ---------------- Line Processing ----------------
        const lines =
          Array.isArray(trResults?.lines) && trResults.lines.length > 0
            ? trResults.lines
            : [
                {
                  id: 'base',
                  label: 'Line 1',
                  value: inputs.totalValue,
                  rows: Array.isArray(trResults?.summaryRows)
                    ? trResults.summaryRows
                    : [],
                },
              ];

        lines.forEach((lineObj: any, lineIdx: number) => {
          const lineEnteredValue = Number(lineObj?.value ?? 0);
          const dutyRows = Array.isArray(lineObj?.rows) ? lineObj.rows : [];

          const rowsToExport =
            dutyRows.length > 0
              ? dutyRows
              : [{ type: 'Base Duty', code: inputs.hts, rate: '0%' }];

          rowsToExport.forEach((dutyRow: any, dutyRowIdx: number) => {
            const lineDutyAmount = calculateLineDuty(
              dutyRow?.rate,
              lineEnteredValue,
            );

            const isFirstRowOfTransaction = lineIdx === 0 && dutyRowIdx === 0;
            const displayFees = isFirstRowOfTransaction ? totalFees : 0;

            const row = [
              (transactionIndex + 1).toString(),
              summaryDate,
              inputs.entryDate,
              inputs.mode,
              inputs.origin,
              inputs.loadingDate,
              inputs.smeltPour,
              inputs.smeltPour,
              (lineIdx + 1).toString(),
              dutyRow?.code || inputs.hts,
              formatPercentage(inputs.materialPct),
              lineEnteredValue.toFixed(2),
              dutyRow?.rate ?? '',
              Number(lineDutyAmount ?? 0).toFixed(2),
              displayFees > 0 ? displayFees.toFixed(2) : '',
              totalEnteredValue.toFixed(2),
              totalDuty.toFixed(2),
              totalFees.toFixed(2),
              totalAmountDue.toFixed(2),
              inputs.productCode,
            ];

            dataRows.push(row.map(escapeCsv));
          });
        });
      });

      // ---------------- 3) Convert to CSV ----------------
      const csvContent = dataRows.map((r) => r.join(',')).join('\r\n');

      // ---------------- 4) Download ----------------
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);

        const safeTicketName =
          (typeof cur_case?.data?.ticketName === 'string' &&
            cur_case.data.ticketName) ||
          (tickets[0]?.ticketName ?? 'tariff_export');

        const filename = `${
          fileName ? fileName : safeTicketName
        }_CBP_Export_${format(new Date(), 'yyyy-MM-dd')}.csv`;

        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        enqueueSnackbar('Successfully exported tariff data', {
          variant: 'success',
        });
      } else {
        enqueueSnackbar('Download not supported in this browser', {
          variant: 'error',
        });
      }
    } catch (error: any) {
      console.error(error);
      enqueueSnackbar(
        `Failed to export data: ${error?.message || 'Unknown error'}`,
        {
          variant: 'error',
        },
      );
    }
  };

  // Helper to calculate duty dollars for a specific rate string
  const calculateLineDuty = (rateStr: string, value: number) => {
    // Simple parser: removes non-numeric chars except dot
    // Note: This approximates complex rates (e.g. specific rates like $0.50/kg)
    // For precise specific rate calc, we'd need the specific unit quantity from the row
    const rateClean = String(rateStr).toLowerCase();

    if (rateClean.includes('free')) {
      return 0;
    }

    const rateVal = parseFloat(rateClean.replace(/[^0-9.]/g, ''));
    if (isNaN(rateVal)) {
      return 0;
    }

    // Heuristic: If rate is > 1 (e.g., 25), treat as percentage (25%).
    // If < 1 (e.g., 0.09), treat as decimal.
    // Exception: Specific rates usually dealt with elsewhere, assuming ad valorem here for bulk.
    const decimal = rateVal > 1 ? rateVal / 100 : rateVal;
    return value * decimal;
  };

  const handleVersionChange = (version: any) => {
    setCurVersion(version);
    const data = decompressData(curVersion.allResults);
    parsedResults = data;
    setPassedDownResults(data);
    setIsHistoryModalOpen(false);
  };

  useEffect(() => {
    if (parsedResults.length > 0) {
      getOpts();
    }
  }, []);

  useEffect(() => {
    if (curVersion) {
      setNewTab(false);
      setCurLevel(isBulkTicket ? 1 : 2);
      const data = decompressData(curVersion.allResults);

      parsedResults = data;
      setPassedDownResults(data);
    }
  }, [curVersion]);

  // Update curVersion when selectedVersionIndex changes (from Activity tab selection)
  useEffect(() => {
    if (
      savedResults.length > 0 &&
      savedResults[selectedVersionIndex]
    ) {
      setCurVersion(savedResults[selectedVersionIndex]);
    }
  }, [selectedVersionIndex]);

  useEffect(() => {
    if (curVersion) {
      if (newTab) {
        setCurLevel(isBulkTicket ? 1 : 2);
        const data = decompressData(curVersion.newResults);

        parsedResults = data;
        setPassedDownResults(data);
      } else {
        setCurLevel(isBulkTicket ? 1 : 2);
        const data = decompressData(curVersion.allResults);

        parsedResults = data;
        setPassedDownResults(data);
      }
    }
  }, [newTab]);

  useEffect(() => {
    if (Object.keys(parsedResults).length > 0) {
      handleFilterClick();
    }
  }, [selectedOpts]);

  useEffect(() => {
    if (triggerCSV) {
      handleCSV();
    }
  }, [triggerCSV]);

  useEffect(() => {
    if (triggerSendPdf) {
      handleSendResultPdf();
    }
  }, [triggerSendPdf]);

  const autoAPICall = async (rowsArr: any) => {
    let allResults: any = [];
    let resCount = 0;
    let totalResults = 0;

    const findMatchingIndex = (val: string, arr: any[]): number | false => {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].field === val) {
          return i;
        }
      }
      return false;
    };

    for (const [i, row] of rowsArr.entries()) {
      const query: automationParams = {
        values: row,
        entState: entityState,
        comState: commodityState,
        row: i + 1,
      };

      const res = await AutomationAPI.automationDataSearch(query);
      resCount++;

      if (res?.success) {
        if (res?.result[0].result?.body?.hits?.total?.value) {
          totalResults =
            totalResults + res?.result[0].result?.body?.hits?.total?.value;
        }

        if (res?.result[1].result?.body?.hits?.total?.value) {
          totalResults =
            totalResults + res?.result[1].result?.body?.hits?.total?.value;
        }

        const entityResArr: any[] = [];
        const commodityResArr: any[] = [];

        await res?.result[0].result?.body?.hits?.hits?.forEach((hit: any) => {
          const val = hit.matched_queries ? hit.matched_queries[0] : '';
          const i = findMatchingIndex(val, entityResArr);
          if (i !== false) {
            entityResArr[i].hits++;
            entityResArr[i].docs.push(hit._source);
          } else {
            entityResArr.push({
              field: val,
              row: res.result[0].row,
              dataSet: 'Entites',
              hits: 1,
              docs: [hit._source],
            });
          }
        });
        await res?.result[1].result?.body?.hits?.hits?.forEach((hit: any) => {
          const val = hit.matched_queries ? hit.matched_queries[0] : '';
          const i = findMatchingIndex(val, commodityResArr);
          if (i !== false) {
            commodityResArr[i].hits++;
            commodityResArr[i].docs.push(hit._source);
          } else {
            commodityResArr.push({
              field: val,
              row: res.result[1].row,
              dataSet: 'Commodities',
              hits: 1,
              docs: [hit._source],
            });
          }
        });

        allResults = [...allResults, ...entityResArr, ...commodityResArr];

        if (resCount === rowsArr.length) {
          return {
            all: [...allResults],
            tot: totalResults,
          };
        }
      } else {
        const error_msg =
          'Error screening data. An API call has failed or timed out.';
        enqueueSnackbar(error_msg, { variant: 'error' });
        return {
          all: [],
          tot: 0,
        };
      }
    }

    return {
      all: [...allResults],
      tot: totalResults,
    };
  };

  const compressData = (data: any) => {
    const stringifiedData = JSON.stringify(data);
    const compressed = pako.gzip(stringifiedData);
    return Buffer.from(compressed).toString('base64'); // Convert to base64 for storage or transmission
  };

  const screenTicket = async () => {
    const curDocInfo =
      savedResults[savedResults.length - 1]?.docInfo;
    setLoading(true);

    const entFilterQuery = {
      lenses: entityState.lenses,
      countries: entityState.countries,
      agencies: entityState.agencies,
      lists: entityState.lists,
      entRes: entityState.fuzzy,
      filterDate: entityState.dateRange,
    };

    const comFilterQuery = {
      lenses: commodityState.comLenses,
      countries: commodityState.countries,
      agencies: commodityState.agencies,
      lists: commodityState.lists,
      entRes: commodityState.fuzzy,
      filterDate: commodityState.dateRange,
    };

    const actObj: any = {
      user: {
        kc_id: cur_user.basics?.id,
        email: cur_user.basics?.email,
        firstName: cur_user.basics?.firstName,
        lastName: cur_user.basics?.lastName,
      },
      action: 'updated the screening parameters and ran a new screen',
      timeStamp: Date.now(),
    };

    const query = {
      entityFilter: entFilterQuery,
      commodityFilter: comFilterQuery,
      lastUpdate: formatted_dt,
      status: 'Complete',
      activity: [...cur_case.data.activity, actObj],
    };

    const obj = await autoAPICall(curDocInfo);
    if (obj) {
      // The raw hit total (obj.tot) can exceed the unique-record count when the
      // entity query surfaces the same BITE Record ID as more than one hit.
      // Change detection keys on BITE Record ID, so dedupe here to keep the
      // saved total consistent with "Results Added" (and with the table rows).
      const dedupeByRecordId = (fieldResults: any[]) =>
        (fieldResults || []).map((fr: any) => {
          const seen = new Set<string>();
          const docs = (fr?.docs || []).filter((d: any) => {
            const key = d?.['BITE Record ID'] ?? d?.record_id;
            if (key === undefined || key === null || key === '') return true;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
          });
          return { ...fr, docs: docs, hits: docs.length };
        });
      const dedupedAll = dedupeByRecordId(obj.all);
      const uniqueTotal = dedupedAll.reduce(
        (sum: number, fr: any) => sum + (fr?.docs?.length || 0),
        0,
      );

      const newArr =
        savedResults.length > 0
          ? getNewDocs(
              decompressData(
                savedResults[savedResults.length - 1].allResults,
              ),
              dedupedAll,
            )
          : [];

      const ticketQuery = {
        ...query,
        curTotal: uniqueTotal,
        curNew: newArr.length,
        results: [
          ...savedResults,
          {
            allResults: compressData(dedupedAll),
            allTotal: uniqueTotal,
            newResults: compressData(newArr),
            newTotal: newArr.length,
            date: formatted_dt,
            docInfo: curDocInfo,
          },
        ],
      };
      const currentEmail = cur_user.basics?.email;
      const ownerEmail = cur_case.data.owner?.email;

      // iterate over sharedWith
      cur_case.data.sharedWith.forEach((email: string) => {
        if (email !== currentEmail) {
          // don’t notify the current user
          handleScreenNotification(
            cur_case.data.ticketName,
            cur_user,
            email,
            cur_case.data._id,
            newArr.length,
          );
        }
      });

      // If current user is in sharedWith but not the owner, also notify the owner
      if (
        cur_case.data.sharedWith.includes(currentEmail) &&
        currentEmail !== ownerEmail &&
        ownerEmail
      ) {
        handleScreenNotification(
          cur_case.data.ticketName,
          cur_user,
          ownerEmail,
          cur_case.data._id,
          newArr.length,
        );
      }
      handleTicket(ticketQuery);
    } else {
      handleTicket(query);
    }
  };

  // On-demand re-screen triggered from the ticket header (AuditHeaderLayout).
  // Mirrors the triggerCSV pattern: the parent flips triggerRescreen, we run the
  // same live screen the old "resubmit" button did, then clear the flag.
  useEffect(() => {
    if (!triggerRescreen) {
      return undefined;
    }
    let cancelled = false;
    const runRescreen = async () => {
      try {
        await screenTicket();
      } finally {
        if (!cancelled && setTriggerRescreen) {
          setTriggerRescreen(false);
        }
      }
    };
    runRescreen();
    return () => {
      cancelled = true;
    };
  }, [triggerRescreen]);

  const handleTicket = async (values: any) => {
    const update = {
      _id: cur_case.data._id,
      ...values.basics,
      ...values,
    };
    const resp = await CasesAPI.updateCase(update);

    if (resp?.success) {
      enqueueSnackbar('Successfully updated case', { variant: 'success' });
      setLoading(false);
      setScreenParamsModal(false);
      reloadPage();
    } else if (resp) {
      const error_msg =
        'Error updating case. Uploaded file(s) may be too large.';
      enqueueSnackbar(error_msg, { variant: 'error' });
      setLoading(false);
      setScreenParamsModal(false);
    }
  };

  const saveParams = async () => {
    const entFilterQuery = {
      lenses: entityState.lenses,
      countries: entityState.countries,
      agencies: entityState.agencies,
      lists: entityState.lists,
      entRes: entityState.fuzzy,
      filterDate: entityState.dateRange,
    };

    const comFilterQuery = {
      lenses: commodityState.comLenses,
      countries: commodityState.countries,
      agencies: commodityState.agencies,
      lists: commodityState.lists,
      entRes: commodityState.fuzzy,
      filterDate: commodityState.dateRange,
    };

    const actObj: any = {
      user: {
        kc_id: cur_user.basics?.id,
        email: cur_user.basics?.email,
        firstName: cur_user.basics?.firstName,
        lastName: cur_user.basics?.lastName,
      },
      action: 'updated the screening parameters of the ticket',
      timeStamp: Date.now(),
    };
    const res = await CasesAPI.updateCase({
      _id: cur_case.data._id,
      entityFilter: entFilterQuery,
      commodityFilter: comFilterQuery,
      activity: [...cur_case.data.activity, actObj],
    });
    if (res?.success) {
      enqueueSnackbar('Screening Parameters Updated!', { variant: 'success' });
      setScreenParamsModal(false);
    } else {
      enqueueSnackbar('There was an error updating this ticket', {
        variant: 'error',
      });
      setScreenParamsModal(false);
    }
  };

  const continueBeneficialOwnershipWorkflow = () => {
    history.push({
      pathname: '/beneficial-ownership-workflow',
      state: {
        resumeBeneficialOwnershipTicket: cur_case.data,
      },
    });
  };

  return (
    <>
      {isBeneficialOwnershipTicket && (
        <div
          className='results-card-frame'
          style={{ paddingBottom: '0px', gap: '12px' }}
        >
          <button
            className='btn-new-automate'
            onClick={continueBeneficialOwnershipWorkflow}
          >
            <div>Continue Workflow</div>
          </button>
        </div>
      )}
      {docType === 'Tariff' && (
        <>
          {cur_case.data.tariffMonitor?.pendingChange && (
            <TariffChangeBanner
              caseId={cur_case.data._id}
              change={cur_case.data.tariffMonitor.pendingChange}
              onReviewed={() => setTrigger(!trigger)}
            />
          )}
          <div ref={tariffComponentRef} data-pdf-root='true'>
            <TariffPage
              forceStatic={true}
              savedTariffResult={cur_case.data.tariffResults}
              tariffJurisdiction={cur_case.data.tariffJurisdiction}
            />
          </div>
        </>
      )}
      {docType === 'Product Screen' && (
        <>
          <div
            className='results-card-frame'
            style={{ gap: '12px', paddingBottom: '0px' }}
          >
            <Link
              to={{
                pathname: '/tariff-checker',
                state: {
                  primary: cur_case.data.commodity.harmonizedScheduleCode,
                },
              }}
            >
              <button className='btn-new-automate'>
                <div> Check Tariff Rate</div>
              </button>
            </Link>
          </div>
        </>
      )}

      {/* Beneficial Ownership opts out of this summary row: its saved-work view
          leads with its own stat tiles and executive summary instead, and the
          row's Last Saved / Entity / Status / Country cards only restated what
          those already show. Every other docType keeps it unchanged. */}
      {docType !== 'Tariff' && !isBeneficialOwnershipTicket && (
        <div className='results-card-frame'>
          <div className='results-card-frame-comp'>
            <div className='results-card-frame-head'>
              {isBeneficialOwnershipTicket ? 'Last Saved' : 'Last Screen'}
            </div>
            <div className='results-card-frame-body'>
              {cur_case.data.lastUpdate
                ? formatDate(cur_case.data.lastUpdate)
                : formatDate(cur_case.data.createdAt.substring(0, 10))}
            </div>
            {isBeneficialOwnershipTicket ? (
              <div
                className='results-card-frame-footer'
                style={{ height: '18px' }}
              >
                {' '}
              </div>
            ) : (
              <div
                className='results-card-frame-footer'
                onClick={() => setIsHistoryModalOpen(true)}
              >
                View History
              </div>
            )}
          </div>
          {isBeneficialOwnershipTicket ? (
            <div className='results-card-frame-comp'>
              <div className='results-card-frame-head'>Entity</div>
              <div className='results-card-frame-body-doc'>
                <div className='results-card-frame-body-texts'>
                  {beneficialOwnershipEntity}
                </div>
              </div>
              <div
                className='results-card-frame-footer'
                style={{ height: '18px' }}
              >
                {' '}
              </div>
            </div>
          ) : (
            <div className='results-card-frame-comp'>
              <div className='results-card-frame-head'>Screening Frequency</div>
              <div className='results-card-frame-body'>
                {cur_case.data.frequency}
              </div>
              <div
                className='results-card-frame-footer'
                onClick={() => setIsFrequencyModalOpen(true)}
              >
                Change
              </div>
            </div>
          )}
          {cur_case.data.requestBody ? (
            <div className='results-card-frame-comp'>
              <div className='results-card-frame-head'>Request Body</div>
              <div className='results-card-frame-body'>{''}</div>
              <div
                className='results-card-frame-footer'
                onClick={() => setIsRequestModalOpen(true)}
              >
                View
              </div>
            </div>
          ) : (
            <div className='results-card-frame-comp'>
              <div className='results-card-frame-head'>Status</div>
              <div className='results-card-frame-body'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='9'
                  height='8'
                  viewBox='0 0 9 8'
                  fill='none'
                  style={{ marginRight: '5px' }}
                >
                  <circle
                    cx='4.5'
                    cy='4'
                    r='3'
                    fill={
                      cur_case.data.status === 'Complete'
                        ? 'var(--card-text)'
                        : cur_case.data.status === 'Pending'
                        ? '#FDB022'
                        : cur_case.data.status === 'New Results'
                        ? '#4895EF'
                        : cur_case.data.status === 'Approved'
                        ? '#47CD89'
                        : cur_case.data.status === 'Rejected'
                        ? '#F04438'
                        : '#B67DFF'
                    }
                  />
                </svg>
                {cur_case.data.status}
              </div>
              <div
                className='results-card-frame-footer'
                onClick={() => setIsApprovalModalOpen(true)}
              >
                Change
              </div>
            </div>
          )}
          <div className='results-card-frame-comp'>
            <div className='results-card-frame-head'>
              {isBeneficialOwnershipTicket ? 'Country' : 'Type'}
            </div>
            <div className='results-card-frame-body-doc'>
              <div className='results-card-frame-body-texts'>
                {isBeneficialOwnershipTicket
                  ? beneficialOwnershipCountry
                  : docType}
              </div>
            </div>
            <div
              className='results-card-frame-footer'
              style={{ height: '18px' }}
            >
              {cur_case.data.commodity?.tradeRegion ||
                cur_case.data.commodity?.tradeType ||
                ' '}
            </div>
          </div>
        </div>
      )}
      <div ref={componentRef}>
        {isEntityTicket && entityTicketData && (
          <div style={{ paddingBottom: '22px' }}>
            <EntityTicketResults
              aiSums={cur_case.data.aiSums ? cur_case.data.aiSums : []}
              beneficialOwnership={cur_case.data.beneficialOwnership || null}
              adverseMedia={cur_case.data.adverseMedia || null}
              results={entityTicketData.results}
              ownershipResults={entityTicketData.ownershipResults}
              entity={cur_case.data.entity}
              pdfMode={isPdfExporting}
            />
          </div>
        )}
        {docType === 'Person / Company' && isBulkTicket && (
          <div
            style={{
              gap: '24px',
              paddingBottom: '22px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <AIEvalEntity
              aiSums={cur_case.data.aiSums ? cur_case.data.aiSums : []}
              pdfMode={isPdfExporting}
            />
          </div>
        )}
        {isProductScreenTicket && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '30px',
              paddingBottom: '22px',
            }}
          >
            {(cur_case.data.commodity?.tradeRegion ||
              cur_case.data.commodity?.tradeType) && (
              <div className='product-screen-region-banner'>
                <span className='product-screen-region-label'>
                  Import Region
                </span>
                <span className='product-screen-region-value'>
                  {cur_case.data.commodity.tradeRegion ||
                    cur_case.data.commodity.tradeType}
                </span>
              </div>
            )}
            <AIEvalProduct
              aiSums={cur_case.data.aiSums ? cur_case.data.aiSums : []}
            />
            <div className='entity-screening-results-heading'>
              <h2>Screening Results</h2>
              <p>
                Product matches across selected lenses. Click any row to view
                match details.
              </p>
            </div>
            <div className='entity-screening-results-shell'>
              <EntityScreeningResultsTable
                isStatic
                variant='product'
                handleSubmit={() => undefined}
                setPage={setProductTablePage}
                page={productTablePage}
                results={productScreeningResults}
                searchTerm={cur_case.data?.ticketName || ''}
              />
            </div>
          </div>
        )}

        {isBeneficialOwnershipTicket && (
          <BeneficialOwnershipTicketResults
            ticket={cur_case.data}
            onViewTree={onViewOwnershipTree}
          />
        )}

        {curLevel > 1 &&
          docType.toLowerCase().includes('api') && (
            <div
              style={{
                gap: '24px',
                paddingBottom: '22px',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <AIEvalEntity aiSums={aiSums ? aiSums : []} />
            </div>
          )}
        {docType !== 'Tariff' &&
          !isEntityTicket &&
          !isProductScreenTicket &&
          !isBeneficialOwnershipTicket && (
            <div className='results-frame'>
              <ResultsTable
                curVersion={curVersion}
                passedDownResults={passedDownResults}
                activeFilter={activeFilter}
                curLevel={curLevel}
                setAISums={setAISums}
                setCurLevel={setCurLevel}
                setIsHistoryModalOpen={setIsHistoryModalOpen}
                handleVisClick={handleVisClick}
                cur_case={cur_case}
                setShareModal={setShareModal}
                setIsCommentsModalOpen={setIsCommentsModalOpen}
                setIsFrequencyModalOpen={setIsFrequencyModalOpen}
                setIsApprovalModalOpen={setIsApprovalModalOpen}
                setScreenParamsModal={setScreenParamsModal}
                handleCSV={() => setTriggerCSV(true)}
                updateFilters={() => setScreenParamsModal(true)}
                resetTable={resetTable}
                newTab={newTab}
                setNewTab={setNewTab}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                currentItems={currentItems}
                setCurrentItems={setCurrentItems}
                whitelistEntity={whitelistEntity}
                isBulkTicket={isBulkTicket}
                removeHit={removeHit}
                removeTrigger={removeTrigger}
              />
            </div>
          )}
      </div>
      <Modal
        open={isFrequencyModalOpen && isReScreenableDocType(cur_case.data.docType)}
        onClose={handleFrequencyCloseModal}
      >
        <ScreeningFrequency
          handleClose={handleFrequencyCloseModal}
          changeFrequency={changeFreq}
          curFreq={cur_case.data.frequency}
        />
      </Modal>
      <Modal open={isApprovalModalOpen} onClose={handleApprovalCloseModal}>
        <ApprovalStatus
          handleClose={handleApprovalCloseModal}
          changeStatus={changeStatus}
          curStatus={cur_case.data.status}
        />
      </Modal>
      <Modal open={isHistoryModalOpen} onClose={handleHistoryCloseModal}>
        <ViewHistoryModal
          handleClose={handleHistoryCloseModal}
          versionsArr={savedResults}
          handleVersionChange={handleVersionChange}
          curVersion={curVersion}
        />
      </Modal>
      <Modal open={isRequestModalOpen} onClose={handleRequestCloseModal}>
        <RequestModal
          handleClose={handleRequestCloseModal}
          requestBody={cur_case.data.requestBody}
        />
      </Modal>

      <Modal
        open={screenParmsModal}
        onClose={() => setScreenParamsModal(false)}
        backdrop='static'
        keyboard={false}
      >
        <ModalLayout
          setFilterMode={setScreenParamsModal}
          submit={submit}
          setSubmit={setSubmit}
          entityState={entityState}
          setEntityState={setEntityState}
          commodityState={commodityState}
          setCommodityState={setCommodityState}
          appliedFilter={appliedFilter}
          handleClear={handleClear}
          setOpenDate={setOpenDate}
          result={savedResults.length > 0}
          handleSaveChanges={saveParams}
          handleSaveAndResubmit={screenTicket}
          screenLoading={loading}
        />
      </Modal>

      <Modal open={openDate} onClose={() => setOpenDate(false)}>
        <DateSelector
          openDate={openDate}
          setOpenDate={setOpenDate}
          state={entityState}
          handleDateChange={handleDateChange}
          setSubmit={setSubmit}
          submit={submit}
        />
      </Modal>
    </>
  );
};

export default ResultsComponent;
